import { useQuery } from '@tanstack/react-query';
import { getFlows } from '../../api/flows';

/** Name of a ForEach/SubFlow target, from the flow list the app already caches. */
export function useFlowName(flowId: string | undefined): string | null {
  const { data: flows } = useQuery({ queryKey: ['flows'], queryFn: getFlows, enabled: !!flowId });
  if (!flowId) return null;
  return flows?.find(f => f.id === flowId)?.name ?? null;
}
